import { Link } from 'react-router-dom';
import { youthData } from '@/mocks/home';

export default function YouthTrainingSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              {youthData.title}
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              {youthData.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {youthData.features.map((f) => (
                <div key={f.title} className="flex gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${f.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{f.title}</h4>
                    <p className="text-foreground-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/category/youth"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              了解青训计划 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20diverse%20group%20of%20children%20and%20teenagers%20playing%20various%20sports%20on%20green%20field%2C%20soccer%20and%20basketball%2C%20coach%20teaching%2C%20bright%20sunny%20day%2C%20warm%20natural%20light%2C%20joyful%20expressions%2C%20professional%20lifestyle%20photography&width=700&height=500&seq=youth-training-section&orientation=landscape"
              alt="云开体育青少年训练"
              className="w-full rounded-xl object-cover"
              style={{ height: '380px' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}